export default [
  {
    name: "Os",
    steps: [
      {
        image: "squelette-anatomie-face.png",
        answers: [
          ["crâne"],
          ["orbite"],
          ["mandibule"],
          ["vertèbre cervicale"],
          ["acromion"],
          ["sternum"],
          ["appendice xiphoïde"],
          ["côte"],
          ["disque intervertébral"],
          ["vertèbre lombaire"],
          ["ulna", "cubitus"],
          ["os iliaque"],
          ["sacrum"],
          ["carpe"],
          ["métacarpien"],
          ["phalange"],
          ["fémur"],
          ["rotule"],
          ["tibia"],
          ["péroné"],
          ["astragale"],
          ["métatarsien"],
          ["phalange"],
          ["clavicule"],
          ["apophyse coracoïde"],
          ["humérus"],
          ["vertèbre dorsale"],
          ["radius"],
          ["aile iliaque"],
          ["grand trochanter"],
          ["petit trochanter"],
        ],
      },
      {
        image: "squelette-anatomie-dos.png",
        answers: [
          ["atlas"],
          ["vertèbre cervicale"],
          ["omoplate"],
          ["vertèbre dorsale"],
          ["côte"],
          ["côte flottante"],
          ["vertèbre lombaire"],
          ["sacrum"],
          ["coccyx"],
          ["fémur"],
          ["condyle externe"],
          ["tibia"],
          ["malléole interne"],
          ["astragale"],
          ["tête de l'humérus"],
          ["humérus"],
          ["olécrane"],
          ["aile iliaque"],
          ["tête du fémur"],
          ["ischion"],
          ["condyle interne"],
          ["péroné"],
          ["malléole externe"],
          ["calcanéum"],
        ],
      },
    ],
  },
  {
    name: "Muscles",
    steps: [
      {
        image: "muscles-vue-face.png",
        answers: [
          ["sterno hyoïdien"],
          ["sterno cleido mastoidien"],
          ["deltoide faisceau antérieur"],
          ["deltoide faisceau extérieur"],
          ["biceps"],
          ["dentelé antérieur"],
          ["brachio-radial"],
          ["rond pronateur"],
          ["extenseur ulnaire du carpe"],
          ["tenseur du fascia lata"],
          ["sartorius"],
          ["vaste externe du quadriceps"],
          ["vaste interne du quadriceps"],
          ["long fibulaire"],
          ["jambier antérieur"],
          ["trapèze"],
          ["grand pectoral"],
          ["petit pectoral"],
          ["brachial"],
          ["oblique externe"],
          ["grand droit de l'abdomen", "abdominaux"],
          ["pectiné"],
          ["droit fémoral du quadriceps"],
          ["gastrocnémien"],
          ["soléaire"],
        ],
      },
      {
        image: "muscles-vue-dos.png",
        answers: [
          ["trapèze"],
          ["infra épineux"],
          ["petit rond"],
          ["grand rond"],
          ["grand dorsal"],
          ["érecteur du rachis"],
          ["grand oblique"],
          ["petit fessier"],
          ["grand fessier"],
          ["vaste externe"],
          ["biceps fémoral"],
          ["semi-tendineux"],
          ["muscle poplité"],
          ["jumeaux"],
          ["soléaire"],
          ["sterno cleido mastoidien"],
          ["deltoide faisceau postérieur"],
          ["deltoide faisceau extérieur"],
          ["chef latéral du triceps"],
          ["chef médial du triceps"],
          ["long chef du triceps"],
          ["cubital postérieur"],
          ["fléchisseur ulnaire du carpe"],
          ["long supinateur"],
          ["grand adducteur"],
          ["semi-tendineux"],
        ],
      },
    ],
  },
];
